import {
  titleUI,
  yesNoSchema,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['your-history-title']),
    yourVeteran: yesNoUI({
      title: content['your-history-question'],
    }),
  },
  schema: {
    type: 'object',
    required: ['yourVeteran'],
    properties: {
      yourVeteran: yesNoSchema,
    },
  },
};
